import { NavLink, generatePath } from 'react-router-dom';
import { IconLoader } from '@ui/src';

// types
import ROUTES from '../../../routes';
import { ColumnCategoriesTypes } from './types';

// components
import ColumnHead from './column-head';

// styles
import cn from './column.module.css';

const ColumnCategories = ({
  categories,
  // path,
  groupId,
  primaryAccountId,
  isLoading,
}: ColumnCategoriesTypes): React.JSX.Element => {
  let content;

  if (isLoading) {
    content = (
      <div className={cn.columnLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = categories.map((item) => (
      <div
        className={`${cn.columnItemWrapper} ${
          item?.isClientAccount ? cn.columnItemWrapperEditable : ''
        }`}
        key={item.id}
      >
        <NavLink
          className={cn.columnItem}
          to={generatePath(ROUTES.CATEGORIES, { categoryId: item.id })}
        >
          <span className={cn.columnItemNumber}>{item?.number}</span>
          {item.name}
        </NavLink>
        {groupId && primaryAccountId && (
          <NavLink
            to={generatePath(ROUTES.CATEGORY_EDIT, {
              categoryId: item.id,
              groupId,
              primaryAccountId,
            })}
            className={cn.editButton}
          >
            edit
          </NavLink>
        )}
      </div>
    ));
  }

  return (
    <div className={cn.column}>
      <ColumnHead title="Category" />
      {content}
    </div>
  );
};

export default ColumnCategories;
